module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("62bHF"))).then(() => parcelRequire('d0iPb'));